import { render, staticRenderFns } from "./BoxOrderList.vue?vue&type=template&id=d373457a&scoped=true"
import script from "./BoxOrderList.vue?vue&type=script&lang=js"
export * from "./BoxOrderList.vue?vue&type=script&lang=js"
import style0 from "./BoxOrderList.vue?vue&type=style&index=0&id=d373457a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d373457a",
  null
  
)

export default component.exports